export const SIGN_IN_FAIL = 'SIGN_IN_FAIL';
